import { TAB } from "../type";

export const CodeTabs: TAB[] = [
  { key: 0, title: "HTML" },
  { key: 1, title: "React" },
  { key: 2, title: "CSS" },
];
